import { Controller } from 'stimulus'

// Tabs carry data-target="crm-tabs.tab" data-tab="name", panels the matching panel target;
// the initial tab comes from data-crm-tabs-active.
export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    const initial = this.data.get('active') || (this.tabTargets[0] && this.tabTargets[0].dataset.tab)
    this.show(initial)
  }

  select(e) {
    e.preventDefault()
    this.show(e.currentTarget.dataset.tab)
  }

  show(name) {
    this.tabTargets.forEach((t) => {
      const on = t.dataset.tab === name
      t.classList.toggle('border-blue-600', on)
      t.classList.toggle('text-blue-600', on)
      t.classList.toggle('border-transparent', !on)
      t.classList.toggle('text-gray-500', !on)
    })
    this.panelTargets.forEach((p) => { p.hidden = p.dataset.tab !== name })
  }
}
